// packages/shared/src/base64.ts — no DOM btoa/atob
const ABC = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
const REV = new Map([...ABC].map((c, i) => [c, i]));
export function bytesToBase64(bytes: Uint8Array): string {
  let out = '';
  for (let i = 0; i < bytes.length; i += 3) {
    const a = bytes[i]!, b = bytes[i + 1], c = bytes[i + 2];
    const n = (a << 16) | ((b ?? 0) << 8) | (c ?? 0);
    out += ABC[(n >> 18) & 63]! + ABC[(n >> 12) & 63]! + (b === undefined ? '=' : ABC[(n >> 6) & 63]!) + (c === undefined ? '=' : ABC[n & 63]!);
  }
  return out;
}
/** Strict standard-alphabet decode: throws on characters outside the alphabet or an impossible length. */
export function base64ToBytes(s: string): Uint8Array {
  const clean = s.replace(/={0,2}$/, '');
  if (clean.length % 4 === 1 || !/^[A-Za-z0-9+/]*$/.test(clean)) throw new Error('base64ToBytes: invalid base64');
  const out = new Uint8Array(Math.floor((clean.length * 3) / 4));
  let o = 0;
  for (let i = 0; i < clean.length; i += 4) {
    const n = ((REV.get(clean[i]!) ?? 0) << 18) | ((REV.get(clean[i + 1] ?? 'A') ?? 0) << 12) | ((REV.get(clean[i + 2] ?? 'A') ?? 0) << 6) | (REV.get(clean[i + 3] ?? 'A') ?? 0);
    if (o < out.length) out[o++] = (n >> 16) & 255;
    if (o < out.length) out[o++] = (n >> 8) & 255;
    if (o < out.length) out[o++] = n & 255;
  }
  return out;
}
